import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  root: {
    // padding: theme.spacing(2),
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_700.main
        : theme.palette.gray_100.main,
    minHeight: '100vh',
    color: 'white',

    width: '100%',
    height: `calc(100% - 48px)`,
    padding: '4px 4px 0 4px'
  },
  mainPaper: {
    height: '100%',
    overflowY: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '8px',
    marginRight: '65px',
    padding: theme.spacing(3),
    color: 'white',
    boxShadow: 'none'
  },
  header: {
    marginBottom: theme.spacing(3),
    textAlign: 'left'
  },
  title: {
    fontWeight: 600,
    color: theme.palette.blue_300.main
  },
  // Estatísticas
  statsContainer: {
    marginBottom: theme.spacing(3)
  },
  statCard: {
    // backgroundColor: '#16213e',
    // color: 'white',
    textAlign: 'center',
    borderRadius: 16,
    boxShadow: 'none'
  },
  statCardContent: {
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.white_100.main,
    padding: `${theme.spacing(2)}px !important`
  },
  statNumberOpen: {
    color: theme.palette.green_200.main
  },
  statNumberPending: {
    color: theme.palette.orange_600.main
  },
  statNumberClosed: {
    color: theme.palette.red_600.main
  },
  statNumberGeneral: {
    color: theme.palette.blue_100.main
  },
  statSecondary: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  statNumberToday: {
    color: theme.palette.red_100.main
  },
  statNumberClosedToday: {
    color: theme.palette.red_400.main
  },
  statLabel: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    fontSize: '0.875rem'
  },
  legend: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    paddingTop: theme.spacing(1)
  },
  legendItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  legendDot: {
    width: 8,
    height: 8,
    borderRadius: '50%'
  },
  // Controles
  controlsContainer: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.white_100.main,
    borderRadius: 8
  },
  sectionTitle: {
    marginBottom: theme.spacing(2)
  },

  //Search
  iconSearch: {
    '& svg': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    }
  },
  // Colunas
  columnsContainer: {
    '& .MuiGrid-item': {
      display: 'flex'
    }
  },
  columnCard: {
    backgroundColor: '#16213e',
    width: '100%',
    height: 'fit-content',
    borderRadius: 8
  },
  columnHeader: {
    padding: theme.spacing(2),
    borderBottom: '1px solid #2a3f5f',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  columnTitle: {
    color: 'white',
    fontWeight: 600
  },
  columnCount: {
    backgroundColor: '#0f3460',
    borderRadius: 12,
    padding: '4px 8px',
    minWidth: 24,
    textAlign: 'center'
  },
  ticketsColumn: {
    padding: theme.spacing(1),
    maxHeight: '60vh',
    overflowY: 'auto',
    ...theme.scrollbarStyles
  },
  emptyColumn: {
    padding: theme.spacing(2),
    textAlign: 'center'
  },
  // Cards de tickets
  ticketMiniCard: {
    backgroundColor: '#0f3460',
    marginBottom: theme.spacing(1),
    borderRadius: 8,
    border: '1px solid #2a3f5f',
    '&:hover': {
      backgroundColor: '#1a4d7a',
      transform: 'translateY(-1px)',
      transition: 'all 0.2s ease'
    }
  },
  ticketMiniCardAction: {
    padding: 0
  },
  ticketMiniCardContent: {
    padding: `${theme.spacing(1.5)}px !important`
  },
  ticketMiniHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  contactAvatar: {
    width: 32,
    height: 32,
    backgroundColor: '#4CAF50',
    fontSize: '0.875rem',
    fontWeight: 600
  },
  ticketMiniInfo: {
    flex: 1
  },
  contactName: {
    color: 'white',
    fontWeight: 500,
    fontSize: '0.875rem',
    lineHeight: 1.2
  },
  contactNumber: {
    color: '#8892b0',
    fontSize: '0.75rem'
  },
  ticketMiniStatus: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: 2
  },
  ticketMiniDetails: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(1)
  },
  ticketMiniFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: '0.75rem'
  },
  unreadBadge: {
    '& .MuiBadge-badge': {
      right: -3,
      top: 2
    }
  },
  // Loading
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4),
    color: 'white'
  }
}))
